import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User, UserService } from './user.service';
import { ModalService, ToastService } from '../../blocks';
import { UserSessionService, SecurityParms } from '../../shared';
import { FastSearchComponent } from '../../blocks/ui-component/fast-search/fast-search.component';

@Component({
    selector: 'sanabel-users',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

    CurrentSecurityLevelOfUser: number;

    UserList: User = <User>{};
    users: User[];
    totalRecords: number = 0;
    SecurityParms;            
    toggleFillter: boolean = true;
    add=0;
    searchPlaceholder = {
        nameAr: 'من فضلك ابحث بكود او اسم المستخدم',
        nameEn: 'Please Search with UserID or UserName'
    }
    @ViewChild('userSearch') fastSearch: FastSearchComponent;
    @Output()
    private emitSelectedUser: EventEmitter<User> = new EventEmitter<User>();
    @Output() private emitAddUser: EventEmitter<number> = new EventEmitter<number>();
    constructor(
        private _userService: UserService,
        public translate: TranslateService,
        private _modalService: ModalService,
        private _userSessionService: UserSessionService,
        private _toastService: ToastService) { }

    ////////..............................#Gouhar...............///

    onSearchClick(_searchObject: any) {
        this.UserList = _searchObject;
        //this.UserList.empId = _searchObject['empCode']; 
        this.UserList.empId = _searchObject['EmpID'];
        this.UserList.userID = _searchObject['userId']
        if (this.UserList.empId == null) {
            this.UserList.empId = 0;
        }
        if (this.UserList.userID == null) {
            this.UserList.userID = 0;
        } 
        this.UserList.offset = 0;
        this.UserList.pageSize = 10;
        this.searchUsers(this.UserList, false);
    }
    ////////..............................#Gouhar...............///

    togglefillter() {
        this.toggleFillter = !this.toggleFillter;
    }

    ////////..............................#Gouhar...............///

    searchUsers(searchObj, paginate: boolean) {
        this.users = [];
        this._userService.searchUsers(searchObj).subscribe(
          res => {
            if (res['returnFlag']) {
              this.users = res.data;
              this.CurrentSecurityLevelOfUser = res.data1[0].securityLevel;
              this.updatePaginator();
              }

                
            }, error => console.log(error),
            () => console.log('Current Login Id Security Level is: ', this.CurrentSecurityLevelOfUser));

    }
    paginate(_parms: any) {
        this.UserList.offset = _parms.first;
        this.UserList.pageSize = _parms.rows;
        this.searchUsers(this.UserList, true);

    } 
  

    ////////..............................#Gouhar...............///
    // to update  totalRecords @input used to calc paging in datatable  
    updatePaginator() {
        this.totalRecords = (this.users ? (this.users.length > 0 ? this.users[0].rowsCount : 0) : 0);

    }
    //-------------End  

    ngOnInit() {
        // this.onSearchClick();
    }


    rowIconClick(actionCode: number, user: User) {
        //#Gouhar .........select user
        if (actionCode == 404) {
            this.add=0;
            this.selectUSer(user);
        }
    }

    /////to emit the user object
    ////////////////////////////////////////////////////////////////////////#gouhar////////////////////////////////////////////////////////////////////////////////////////////////////////////

    selectUSer(user) {
        this._userSessionService.setSessionKey('userParms', {});
        this._userSessionService.setSessionKey('USERCODE', {});
        if (user) {
            this._userSessionService.setSessionKey('USERCODE', user.userID);
            this._userSessionService.setSessionKey('userParms', user);
            this.emitSelectedUser.emit(user);
            this.emitAddUser.emit(56);
        }

    }
    ////////////////////////////////////////////////////////////////////////#gouhar////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //fun to reset emp search an reset emp obj in emp .component 
    nextStep() {
        this.add=1;
        this._userSessionService.setSessionKey('userParms', {});
        this._userSessionService.setSessionKey('ResetUser',1)
        this.emitAddUser.emit(56);
        this.emitSelectedUser.emit();
        this.ngOnInit();

    }
    ////////////////////////////////////////////////////////////////////////#gouhar/////////////////////////////////////////////////////////////////////
}

